import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {CustomerApproval} from '../../features/customer-approval/customer-approval';


@Injectable({
  providedIn: 'root'
})
export class CustomerApprovalService extends DataService {

  private baseURI = this.apiUri + '/customerregistrationapproval/';
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getCustomerApprovalDetails(userRegisterId: any): Observable<any> {
    return this.http.get(this.baseURI + userRegisterId + '/userregisterid');
  }

  updateCustomerApprovalDetails(customerApproval: CustomerApproval): Observable<any> {
    return this.http.post(this.baseURI, customerApproval, {responseType: 'text'});
  }


}
